import { combineReducers, configureStore } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

import { clientApi, UserReadDto } from "@/store/clientApi";
import caseUploadsSlice, { uploadsListener } from "@/store/slices/caseUploadsSlice";
import casesSlice, { caseUploadsListener } from "@/store/slices/casesSlice";
import dashboardSlice from "@/store/slices/dashboardSlice";
import detailsDrawerSlice from "@/store/slices/detailsDrawerSlice";
import downloadingCasesSlice from "@/store/slices/downloadingCasesSlice";
import modalSlice from "@/store/slices/modalSlice";
import orgSlice from "@/store/slices/orgSlice";
import tabSlice from "@/store/slices/tabSlice";
import tableSlice from "@/store/slices/tableSlice";
import templateSlice from "@/store/slices/templateSlice";
import termsAcceptedSlice from "@/store/slices/termsAcceptedSlice";
import thumbnailsCacheSlice from "@/store/slices/thumbnailsCacheSlice";
import viewportSlice from "@/store/slices/viewportSlice";

//import { WebsocketEventMiddleware, wsEventSlice } from "@/store/slices/wsEventSlice";

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  attachReduxState: true
});

const RootReducer = combineReducers({
  [clientApi.reducerPath]: clientApi.reducer,
  tables: tableSlice,
  uploads: caseUploadsSlice,
  cases: casesSlice,
  downloadingCases: downloadingCasesSlice,
  detailsDrawer: detailsDrawerSlice,
  //wsEvents: wsEventSlice.reducer,
  tabs: tabSlice,
  organisation: orgSlice,
  termsAccepted: termsAcceptedSlice,
  template: templateSlice,
  viewport: viewportSlice,
  modals: modalSlice,
  thumbnailsCache: thumbnailsCacheSlice,
  dashboard: dashboardSlice
});

export const store = configureStore({
  reducer: RootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(uploadsListener.middleware, caseUploadsListener.middleware).concat(clientApi.middleware),
  //.concat(WebsocketEventMiddleware()),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
  devTools: true
});

export const patchUsers = (users: UserReadDto[]) => {
  store.dispatch(
    clientApi.util.updateQueryData("searchUsersApiV1UsersSearchGet", {}, (draftUsers) => {
      draftUsers.content?.concat(users);
    })
  );
};

export type RootState = ReturnType<typeof RootReducer>;
export type AppDispatch = typeof store.dispatch;
